<template>
  <div>
    <h3>Рассылка промокодов</h3>
    <p>Команда {{host}} благодарит Вас за оказанное доверие. В знак признательности, мы будем регулярно рассылать промокоды постоянным игрокам. Приятной игры!</p>
  </div>
</template>
<script>
  export default {
    name: 'bonus-rules-mailing-ru',
    computed: {
      host() {
        return window.location.hostname;
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/ru.vue